// Actions
import { start, error, success, feedback, end, warning, donePlaying } from 'REDUCERS/speakersSlice';
import { permissionsRequest } from 'REDUCERS/appSlice';

// Utils
import speakersCheck from 'CHECKS/speakers/speakersCheck';
import { NO, RETRY, TONE_AUDIO_ID, YES } from 'UTILS/constants';
import { storeDeviceId } from 'UTILS/callbacks';

export default store => {
  const handleError = (type, payload) => store.dispatch(error({ type, data: payload }));
  const handlePlayed = () => store.dispatch(donePlaying());

  return next => async action => {
    switch (action.type) {
      case permissionsRequest.toString():
        // This will allow us to play a sound later even without any user interaction
        await speakersCheck.play({
          audioElementId: TONE_AUDIO_ID,
          volume: 0,
          logger: store.getState().app.isVerbose ? console : undefined,
          immediate: true,
        });
        next(action);
        return;
      case start.toString():
        next(action);
        await speakersCheck.play({
          audioElementId: TONE_AUDIO_ID,
          onError: handleError,
          onPlayed: handlePlayed,
          logger: store.getState().app.isVerbose ? console : undefined,
          deviceId: store.getState().checks.speakers.selectedAudioOutputId,
        });
        return;
      case feedback.toString():
        next(action);
        switch (action.payload.answer) {
          case RETRY:
            store.dispatch(start());
            break;
          case YES:
            store.dispatch(success({ type: 'tone_heard' }));
            store.dispatch(end());
            break;
          case NO:
            store.dispatch(warning({ type: 'tone_not_heard' }));
            store.dispatch(end());
            break;
        }
        return;
      case success.toString(): {
        next(action);
        if (store.getState().checks.speakers.selectedAudioOutputId) {
          storeDeviceId('audioOutput', store.getState().checks.speakers.selectedAudioOutputId);
        }
        return;
      }
      case error.toString(): {
        next(action);
        store.dispatch(end());
        return;
      }
      default:
        return next(action);
    }
  };
};
